document.addEventListener('DOMContentLoaded', (event) => {
  document.addEventListener('click', (e) => {
    const label = e.target.closest('label[data-variant-option-value-label]');
    if (!label) return;

    const productForm = document.querySelector("[bss-b2b-main-product-form], [bss-b2b-quickview-product-form]");
    BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', { productForm });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (e) {
    const quickViewBtn = e.target.closest('[bss-b2b-btn-quickview]');
    if (quickViewBtn) {
      setTimeout(() => {
        document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
      }, 2000);
    }
  });

  if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (item.target.classList?.contains('bss-b2b-price-variant')) {
            BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);
  }
});
